<template>
    <div class="">

        <div class="tabs_div">
            <div class="tabs_div_left">
                <DatePicker type="date" v-model="current_day" placeholder="选择日期" style="width: 120px;margin-right:10px"
                    @on-change='current_date_change()' />
                <Tabs size="small" type="card" v-model="tabs_model" @on-tab-remove="tab_remove"
                    @on-contextmenu="tabs_contextmenu_change" @on-click='tabs_change()'>
                    <TabPane context-menu closable v-for="(item, i) in shift_list" :key="i" :label='item.name'
                        :name="item">
                    </TabPane>
                    <template #contextMenu>
                        <DropdownItem @click="editor_shift(item)">编辑</DropdownItem>
                        <DropdownItem @click="shift_info(item)">详情</DropdownItem>

                    </template>
                </Tabs>
            </div>
            <!-- {{ tabs_model }} -->
            <div>
                <Button @click="add_shift" size="small" style="margin-left:20px;font-size:10px">+ 创建班次</Button>
                <Button @click="add_people_show = true" type="primary" size="small"
                    style="margin-left:10px;font-size:10px">+
                    添加人员</Button>
            </div>

        </div>
        <div class="table_box">
            <Spin fix size="large" v-if="table_loading"></Spin>
            <Table size="small" :height="windowHeight - 110" :columns="shift_columns" :data="shift_data">


                <template #sign_in_list="{ row }">
                    <span v-for="(item, i) in row.sign_in_list"
                        :class="item.status == 0 ? 'sign_tag_up' : 'sign_tag_down'" :key="i">{{ item.status == 1 ? '下班'
        : '上班'
}} - {{ item.create_time }}</span>
                    <span v-if="row.sign_in_list.length == 0">无</span>
                </template>
            </Table>
            <!-- <div class="content_page">
                <Page :total="100" />
            </div> -->
        </div>
        <div class="">


        </div>

        <Modal v-model="add_people_show" title="添加人员" :footer-hide="true" width="400px">
            <div>
                <Spin fix size="large" v-if="add_people_loading"></Spin>



                <div class="add_shift_field">
                    <div class="add_shift_field_title">
                        姓名
                    </div>
                    <div>
                        <Input v-model="add_people_data.name" placeholder="真实姓名" style="width: 230px" />
                    </div>
                </div>
                <div class="add_shift_field">
                    <div class="add_shift_field_title">
                        身份证号
                    </div>
                    <div>
                        <Input v-model="add_people_data.idcard" placeholder="真实身份证号" style="width: 230px" />
                    </div>
                </div>
                <div class="add_shift_field">
                    <div class="add_shift_field_title">
                        手机号码
                    </div>
                    <div>
                        <Input v-model="add_people_data.phone" placeholder="真实手机号" style="width: 230px" />
                    </div>
                </div>
                <div class="add_shift_field">
                    <div class="add_shift_field_title">
                        备注
                    </div>
                    <div>
                        <Input v-model="add_people_data.remarks" placeholder="输入备注(选填)" style="width: 230px" />
                    </div>
                </div>

            </div>
            <div class="button_div">

                <Button style="margin-right:10px" @click="batch_import()">+批量导入</Button>
                <Button type="primary" @click="add_people_request()">确认添加</Button>
            </div>
        </Modal>



        <Modal v-model="add_shift_show" title="创建班次" :footer-hide="true" width="400px">
            <div>
                <Spin fix size="large" v-if="add_shift_loading"></Spin>

                <div class="add_shift_field">
                    <div class="add_shift_field_title">
                        当前日期：
                    </div>
                    <div>
                        {{ current_day.getFullYear() }}/{{ current_day.getMonth() + 1 }}/{{ current_day.getDate() }}
                    </div>
                </div>

                <div class="add_shift_field">
                    <div class="add_shift_field_title">
                        班次别名：
                    </div>
                    <div>
                        <Input v-model="add_shift_name" placeholder="建议输入白晚班或以时间段命名" style="width: 230px" />
                    </div>
                </div>
                <div class="add_shift_field">
                    <div class="add_shift_field_title">
                        班次开始时段：
                    </div>
                    <div>
                        <DatePicker type="datetime" format="yyyy-MM-dd HH:mm" :value="add_shift_start_time"
                            placeholder="班次开始时间" style="width: 200px" @on-change="add_start_time_change" />

                        <!-- <TimePicker v-model="add_shift_start_time"  type="datetime" placeholder="班次开始时段"
                            style="width: 230px" /> -->
                    </div>
                </div>
                <div class="add_shift_field">
                    <div class="add_shift_field_title">
                        班次结束时段：
                    </div>
                    <div>
                        <DatePicker type="datetime" format="yyyy-MM-dd HH:mm" :value="add_shift_end_time"
                            placeholder="班次结束时间" style="width: 200px" @on-change="add_end_time_change" />


                    </div>
                </div>
            </div>
            <div class="button_div">
                <Button type="primary" @click="affirm_add_shift()">确认创建</Button>
            </div>
        </Modal>

        <Modal v-model="editor_shift_show" title="更新班次" :footer-hide="true" width="400px">
            <div>

                <div class="add_shift_field">
                    <div class="add_shift_field_title">
                        当前日期：
                    </div>
                    <div>
                        {{ current_day.getFullYear() }}/{{ current_day.getMonth() + 1 }}/{{ current_day.getDate() }}
                    </div>
                </div>

                <div class="add_shift_field">
                    <div class="add_shift_field_title">
                        班次别名：
                    </div>
                    <div>
                        <Input v-model="shift_upate_data.name" placeholder="建议输入白晚班或以时间段命名" style="width: 230px" />
                    </div>
                </div>
                <div class="add_shift_field">
                    <div class="add_shift_field_title">
                        班次开始时段：
                    </div>
                    <div>
                        <DatePicker type="datetime" format="yyyy-MM-dd HH:mm" v-model="shift_upate_data.start_time_str"
                            placeholder="班次开始时间" style="width: 200px" @on-change="update_start_time_change" />
                    </div>
                </div>
                <div class="add_shift_field">
                    <div class="add_shift_field_title">
                        班次结束时段：
                    </div>
                    <div>
                        <DatePicker type="datetime" format="yyyy-MM-dd HH:mm" v-model="shift_upate_data.end_time_str"
                            placeholder="班次开始时间" style="width: 200px" @on-change="update_end_time_change" />
                    </div>
                </div>
            </div>
            <div class="button_div">
                <Button type="primary" @click="update_shift()">确认更新</Button>
            </div>
        </Modal>
    </div>



</template>

<script>
import { http,open_new_page } from "@/utils/http.js";

export default {
    name: 'daily_shift',
    props: ['current_project'],
    components: {
    },
    data() {
        return {
            windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度

            //系统列表
            table_data: [],
            columns: [],
            table_loading: false,
            page: 1,

            shift_list: [

            ],
            add_shift_loading: false,
            add_shift_show: false,
            add_shift_name: '',
            add_shift_start_time: '',
            add_shift_start_time_tsp: 0,
            add_shift_end_time: '',
            add_shift_end_time_tsp: 0,
            current_day: new Date(),

            editor_shift_show: false,
            current_shift: {},
            shift_upate_data: {
                shift_id: '',
                name: '',
                start_time: 0,
                start_time_str: '',
                end_time: 0,
                end_time_str: ''
            },

            tabs_model: '',
            add_people_show: false,
            add_people_loading: false,
            add_people_data: {
                name: '',
                idcard: '',
                phone: '',
                remarks: ''
            },


            shift_loading: false,
            shift_columns: [],
            shift_data: []


        }
    },

    mounted() {
        this.get_shift_list()
    },

    methods: {

        batch_import() {
            var shift_id = this.tabs_model.shift_id
            if(!shift_id){
                this.$Message.error('没有班次，请先添加')
                return
            }
            var project_id= this.current_project.project_id
            open_new_page('/workbench/daily_settlement/import?project_id='+ project_id +'&shift_id='+shift_id)
           
        },

        tabs_change(e) {
            console.log('班次变化', e)
            this.get_people_list()

        },

        current_date_change() {
            console.log('当前日期变化')
            this.shift_data = []
            this.get_shift_list()
        },

        //班次员工列表
        get_people_list() {
            var shift_id = this.tabs_model.shift_id


            var that = this
            var obj = {
                project_id: that.current_project.project_id,
                shift_id: shift_id,
                current_tsp: this.current_day.getTime() / 1000

            }
            this.add_people_loading = true
            http("post", process.env.VUE_APP_HOST + "/daily/shift_people", obj, true).then(
                (res) => {
                    that.add_people_loading = false
                    if (res.code == 0) {
                        // that.$Message.success({
                        //     content: res.msg,
                        //     duration: 3,
                        // });
                        that.shift_columns = res.data.columns
                        that.shift_data = res.data.table_data

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }

                }
            ).catch((res) => {
                console.log(res, '请求出错')
            })
        },

        add_people_request() {
            var shift_id = this.tabs_model.shift_id
            if (this.add_people_data.name == '') {
                this.$Message.error('请输入姓名')
                return
            }
            if (this.add_people_data.idcard.length != 18) {
                this.$Message.error('请输入18位身份证号')
                return
            }
            if (this.add_people_data.phone.length != 11) {
                this.$Message.error('请输入11位手机号')
                return
            }

            var that = this
            var obj = {
                project_id: that.current_project.project_id,
                shift_id: shift_id,
                name: this.add_people_data.name,
                idcard: this.add_people_data.idcard,
                phone: this.add_people_data.phone,
                remarks: this.add_people_data.remarks
            }
            this.add_people_loading = true
            http("post", process.env.VUE_APP_HOST + "/daily/add_people", obj, true).then(
                (res) => {
                    that.add_people_loading = false
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        that.add_people_show = false

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }

                }
            ).catch((res) => {
                console.log(res, '请求出错')
            })
        },

        update_shift() {
            var that = this
            var obj = {
                project_id: that.current_project.project_id,
                shift_id: that.shift_upate_data.shift_id,
                name: that.shift_upate_data.name,
                start_time: that.shift_upate_data.start_time,
                end_time: that.shift_upate_data.end_time,
            }

            http("post", process.env.VUE_APP_HOST + "/daily/update_shift", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        that.editor_shift_show = false
                        that.get_shift_list()
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }

                }
            ).catch((res) => {
                console.log(res, '请求出错')
            })
        },

        getYMDHMS(timestamp) {
            let time = new Date(timestamp)
            let year = time.getFullYear()
            let month = time.getMonth() + 1
            let date = time.getDate()
            let hours = time.getHours()
            let minute = time.getMinutes()
            let second = time.getSeconds()

            if (month < 10) { month = '0' + month }
            if (date < 10) { date = '0' + date }
            if (hours < 10) { hours = '0' + hours }
            if (minute < 10) { minute = '0' + minute }
            if (second < 10) { second = '0' + second }
            return year + '-' + month + '-' + date + ' ' + hours + ':' + minute + ':' + second
        },

        shift_info() {
            console.log(this.current_shift)
            this.$Notice.success({
                title: '班次详情',
                duration: 10,
                desc: '班次名称：' + this.current_shift.label + '<br>开始时间：' + String(this.getYMDHMS(this.current_shift.name.start_time * 1000)) + '<br> 结束时间：' + String(this.getYMDHMS(this.current_shift.name.end_time * 1000))
            });
        },

        update_end_time_change(e) {
            console.log(e)
            var tsp = new Date(e).getTime() / 1000
            console.log(tsp)
            this.shift_upate_data.end_time = tsp
        },

        update_start_time_change(e) {
            console.log(e)
            var tsp = new Date(e).getTime() / 1000
            console.log(tsp)
            this.shift_upate_data.start_time = tsp
        },

        add_start_time_change(e) {
            console.log(e)
            var tsp = new Date(e).getTime() / 1000
            console.log(tsp)
            this.add_shift_start_time_tsp = tsp
        },

        add_end_time_change(e) {
            console.log(e)
            var tsp = new Date(e).getTime() / 1000
            console.log(tsp)
            this.add_shift_end_time_tsp = tsp
        },

        tabs_contextmenu_change(e) {
            console.log(e)
            this.current_shift = e
        },

        editor_shift(e) {
            console.log(e)

            this.editor_shift_show = true
            this.shift_upate_data.shift_id = this.current_shift.name.shift_id;
            this.shift_upate_data.name = this.current_shift.label;
            this.shift_upate_data.start_time = this.current_shift.name.start_time
            this.shift_upate_data.start_time_str = new Date(this.getYMDHMS(this.current_shift.name.start_time * 1000))
            this.shift_upate_data.end_time = this.current_shift.name.end_time
            this.shift_upate_data.end_time_str = new Date(this.getYMDHMS(this.current_shift.name.end_time * 1000))
        },

        tab_remove(e) {
            console.log(e)

            var that = this
            this.$Modal.confirm({
                title: '危险操作',
                content: '<p>你正在删除班次，是否真的要删除？</p>',
                onOk: () => {
                    var obj = {
                        project_id: that.current_project.project_id,
                        shift_id: that.shift_list[e]['shift_id']
                    }

                    http("post", process.env.VUE_APP_HOST + "/daily/del_shift", obj, true).then(
                        (res) => {
                            if (res.code == 0) {
                                that.$Message.success({
                                    content: res.msg,
                                    duration: 3,
                                });
                                that.get_shift_list()
                            } else {
                                that.$Message.error({
                                    content: res.msg,
                                    duration: 3,
                                });
                            }

                        }
                    ).catch((res) => {
                        console.log(res, '请求出错')
                    })
                },
                onCancel: () => {

                }
            });



        },



        get_shift_list() {

            var that = this
            var year = this.current_day.getFullYear()
            var month = this.current_day.getMonth() + 1
            var day = this.current_day.getDate()
            var obj = {
                project_id: this.current_project.project_id,

                year: year,
                month: month,
                day: day,

            }

            http("post", process.env.VUE_APP_HOST + "/daily/shift_list", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.shift_list = res.data.shift_list
                        if (that.shift_list.length > 0) {
                            that.tabs_model = res.data.shift_list[0]

                            //获取员工列表
                            that.get_people_list()
                        }

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }

                }
            ).catch((res) => {


                console.log(res, '请求出错')
            })
        },

        affirm_add_shift() {

            var that = this
            var year = this.current_day.getFullYear()
            var month = this.current_day.getMonth() + 1
            var day = this.current_day.getDate()
            var obj = {
                project_id: this.current_project.project_id,
                name: this.add_shift_name,
                year: year,
                month: month,
                day: day,
                start_time: this.add_shift_start_time_tsp,
                end_time: this.add_shift_end_time_tsp
            }

            if (!year) {
                this.$Message.error('年异常')
                return
            }
            if (!month) {
                this.$Message.error('年异常')
                return
            }
            if (!day) {
                this.$Message.error('年异常')
                return
            }
            if (!obj.project_id) {
                this.$Message.error('项目id异常')
                return
            }
            if (!obj.name) {
                this.$Message.error('请输入别名')
                return
            }
            if (!obj.start_time) {
                this.$Message.error('请选择班次开始时段')
                return
            }
            if (!obj.end_time) {
                this.$Message.error('请选择班次结束时段')
                return
            }

            this.add_shift_loading = true
            http("post", process.env.VUE_APP_HOST + "/daily/create_shift", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        that.get_shift_list()
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                    that.add_shift_loading = false
                    that.add_shift_show = false
                }
            ).catch((res) => {
                that.add_shift_loading = false

                console.log(res, '请求出错')
            })
        },

        //点击新班次
        add_shift() {
            this.add_shift_show = true
        },


        //获取用户列表
        get_user_list() {
            var that = this
            var obj = {
                page: this.page
            }
            this.table_loading = true
            http("post", process.env.VUE_APP_HOST + "/user_manage/user_list", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.table_data = res.data.table_data
                        that.columns = res.data.columns

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                    that.table_loading = false
                }
            ).catch((res) => {
                that.table_loading = false

                console.log(res, '请求出错')
            })
        },

        window_change() {
            var that = this;
            // <!--把window.onresize事件挂在到mounted函数上-->
            window.onresize = () => {
                return (() => {
                    window.fullHeight = document.documentElement.clientHeight;
                    window.fullWidth = document.documentElement.clientWidth;
                    that.windowHeight = window.fullHeight;  // 高
                    that.windowWidth = window.fullWidth; // 宽
                })()
            };
        }
    }
}
</script>

<style scoped>
.sign_tag_down {
    padding: 1px 8px;
    background-color: #11a53e;
    color: rgb(255, 255, 255);
    border-radius: 50px;
    margin-right: 5px;
    margin-bottom: 3px;
}

.sign_tag_up {
    border-radius: 50px;
    padding: 1px 8px;
    background-color: #428cc8;
    color: #fff;
    margin-right: 5px;
    margin-bottom: 3px;
}

.add_shift_field_title {
    width: 120px;
    flex-shrink: 0;
}

.add_shift_field {
    display: flex;
    margin-bottom: 10px;
    align-items: center;
}

.button_div {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
    ;
}

.tabs_div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    border-bottom: 1px solid rgb(235, 235, 235);
    padding-bottom: 5px;
    ;
}

.tabs_div_left {
    display: flex;
    align-items: center;
}

.content_page {
    display: flex;
    justify-content: center;
    padding-top: 10px;
}

:deep(.ivu-tabs-bar) {
    margin-bottom: 10px;
}

.circular {
    width: 25px;
    height: 25px;
}

.table_box {
    position: relative;
}

.add_sys_button {
    margin-top: 20px;
    text-align: right;
}

.form_item_title {
    flex-shrink: 0;
    width: 100px;
}

.form_item {
    display: flex;
    align-items: center;
}

.options {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
}

.content {
    width: calc(100% - 180px);
    background-color: #fff;
    position: absolute;
    right: 0px;
    top: 0px;
    height: 100vh;
    padding: 10px;
}

.main {
    background: #f5f7f9;
    min-height: 100vh;
}
</style>